var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 115,
    viewBox: "0 0 116 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3971 36.8101C41.0049 41.1029 43.4437 45.0364 46.5736 48.3851C49.7035 51.7338 53.463 54.4319 57.6367 56.3248C61.8104 58.2177 66.3162 59.2681 70.8958 59.4159C75.4754 59.5638 80.0389 58.806 84.3247 57.1862L84.4619 57.1347C66.3237 63.9452 57.1383 84.0598 63.9107 102.097L39.3971 36.8101Z",
    fill: "#00CCA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3974 36.8103C41.0115 41.1001 41.7638 45.6661 41.6112 50.2467C41.4586 54.8272 40.4042 59.3324 38.5083 63.504C36.6124 67.6757 33.9123 71.432 30.5626 74.5576C27.213 77.6832 23.2796 80.1168 18.9878 81.719L18.8551 81.7688C36.9711 74.9666 57.1474 84.0566 63.9198 102.093L39.3974 36.8103Z",
    fill: "#00CCA8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.603 6.91497C66.5056 9.3247 67.8746 11.5327 69.6315 13.4125C71.3885 15.2922 73.4988 16.8068 75.8417 17.8694C78.1846 18.9319 80.7138 19.5216 83.2846 19.6046C85.8553 19.6875 88.417 19.2622 90.8228 18.3529L90.8998 18.324C80.7181 22.147 75.5619 33.4382 79.3635 43.563L65.603 6.91497Z",
    fill: "#00CCA8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6044 6.91488C66.5105 9.32295 66.9327 11.886 66.8471 14.4573C66.7615 17.0285 66.1696 19.5575 65.1053 21.8992C64.0411 24.2409 62.5254 26.3495 60.6451 28.104C58.7648 29.8586 56.5568 31.2246 54.1476 32.124L54.0731 32.152C64.2424 28.3336 75.5682 33.4362 79.3699 43.561L65.6044 6.91488Z",
    fill: "#00CCA8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomStars);
export default __webpack_public_path__ + "static/media/bottomStars.db773f28.svg";
export { ForwardRef as ReactComponent };